import { TransactionType } from './banking.types';
export var PayCenterTransactionType;
(function (PayCenterTransactionType) {
    PayCenterTransactionType["PREAUTH"] = "PREAUTH";
    PayCenterTransactionType["OPEN_PREAUTH"] = "OPEN_PREAUTH";
    PayCenterTransactionType["DECLINED_PREAUTH"] = "DECLINED_PREAUTH";
    PayCenterTransactionType["PREAUTH_WITH_MATCHING_INFO"] = "PREAUTH_WITH_MATCHING_INFO";
    PayCenterTransactionType["CLEARING"] = "CLEARING";
    PayCenterTransactionType["CLEARING_WITH_MATCHING_PREAUTH"] = "CLEARING_WITH_MATCHING_PREAUTH";
    PayCenterTransactionType["REDEMPTION"] = "REDEMPTION";
    PayCenterTransactionType["DECLINED_REDEMPTION"] = "DECLINED_REDEMPTION";
    PayCenterTransactionType["STOPPABLE_REDEMPTION"] = "STOPPABLE_REDEMPTION";
    PayCenterTransactionType["DIRECT_DEBIT"] = "DIRECT_DEBIT";
    PayCenterTransactionType["DIRECT_DEBIT_DECLINED"] = "DIRECT_DEBIT_DECLINED";
    PayCenterTransactionType["DIRECT_DEBIT_NOT_DECLINED"] = "DIRECT_DEBIT_NOT_DECLINED";
    PayCenterTransactionType["MDES_TOKENIZATION"] = "MDES_TOKENIZATION";
    PayCenterTransactionType["REPLENISHMENT"] = "REPLENISHMENT";
})(PayCenterTransactionType || (PayCenterTransactionType = {}));
export const payCenter2BankingTypeMap = {
    [PayCenterTransactionType.PREAUTH]: TransactionType.AUTHORIZATION_PENDING,
    [PayCenterTransactionType.OPEN_PREAUTH]: TransactionType.AUTHORIZATION_OPEN,
    [PayCenterTransactionType.DECLINED_PREAUTH]: TransactionType.AUTHORIZATION_DECLINED,
    [PayCenterTransactionType.PREAUTH_WITH_MATCHING_INFO]: TransactionType.AUTHORIZATION_WITH_INFO,
    [PayCenterTransactionType.CLEARING]: TransactionType.SETTLEMENT,
    [PayCenterTransactionType.CLEARING_WITH_MATCHING_PREAUTH]: TransactionType.SETTLEMENT_WITH_AUTHORIZATION,
    [PayCenterTransactionType.REDEMPTION]: TransactionType.WITHDRAWAL,
    [PayCenterTransactionType.DECLINED_REDEMPTION]: TransactionType.REFUND_DECLINED,
    [PayCenterTransactionType.STOPPABLE_REDEMPTION]: TransactionType.REFUND_STOPPABLE,
    [PayCenterTransactionType.DIRECT_DEBIT]: TransactionType.DIRECT_DEBIT,
    [PayCenterTransactionType.DIRECT_DEBIT_DECLINED]: TransactionType.DIRECT_DEBIT_DECLINED,
    [PayCenterTransactionType.DIRECT_DEBIT_NOT_DECLINED]: TransactionType.DIRECT_DEBIT_PROCESSED,
    [PayCenterTransactionType.MDES_TOKENIZATION]: TransactionType.TOKEN_PROVISIONING,
    [PayCenterTransactionType.REPLENISHMENT]: TransactionType.DEPOSIT,
};
export const banking2PayCenterTypeMap = {
    [TransactionType.DEPOSIT]: PayCenterTransactionType.REPLENISHMENT,
    [TransactionType.WITHDRAWAL]: PayCenterTransactionType.REDEMPTION,
    [TransactionType.AUTHORIZATION_PENDING]: PayCenterTransactionType.PREAUTH,
    [TransactionType.AUTHORIZATION_OPEN]: PayCenterTransactionType.OPEN_PREAUTH,
    [TransactionType.AUTHORIZATION_DECLINED]: PayCenterTransactionType.DECLINED_PREAUTH,
    [TransactionType.AUTHORIZATION_WITH_INFO]: PayCenterTransactionType.PREAUTH_WITH_MATCHING_INFO,
    [TransactionType.SETTLEMENT]: PayCenterTransactionType.CLEARING,
    [TransactionType.SETTLEMENT_WITH_AUTHORIZATION]: PayCenterTransactionType.CLEARING_WITH_MATCHING_PREAUTH,
    [TransactionType.REFUND]: PayCenterTransactionType.REDEMPTION,
    [TransactionType.REFUND_DECLINED]: PayCenterTransactionType.DECLINED_REDEMPTION,
    [TransactionType.REFUND_STOPPABLE]: PayCenterTransactionType.STOPPABLE_REDEMPTION,
    [TransactionType.DIRECT_DEBIT]: PayCenterTransactionType.DIRECT_DEBIT,
    [TransactionType.DIRECT_DEBIT_DECLINED]: PayCenterTransactionType.DIRECT_DEBIT_DECLINED,
    [TransactionType.DIRECT_DEBIT_PROCESSED]: PayCenterTransactionType.DIRECT_DEBIT_NOT_DECLINED,
    [TransactionType.TOKEN_PROVISIONING]: PayCenterTransactionType.MDES_TOKENIZATION,
};
export function mapPayCenterToBankingType(payCenter) {
    return payCenter2BankingTypeMap[payCenter];
}
export function mapBankingToPayCenterType(banking) {
    return banking2PayCenterTypeMap[banking];
}
export var CardReorderReason;
(function (CardReorderReason) {
    CardReorderReason["LOST"] = "LOST";
    CardReorderReason["DATA_CORRUPTION"] = "DATA_CORRUPTION";
    CardReorderReason["MISUSE"] = "MISUSE";
    CardReorderReason["DEFECT"] = "DEFECT";
    CardReorderReason["WITHDRAWN"] = "WITHDRAWN";
    CardReorderReason["EXPIRED"] = "EXPIRED";
    CardReorderReason["CARD_TYPE_CHANGE"] = "CARD_TYPE_CHANGE";
    CardReorderReason["NAME_CHANGE"] = "NAME_CHANGE";
})(CardReorderReason || (CardReorderReason = {}));
export var PayCenterPropertyName;
(function (PayCenterPropertyName) {
    PayCenterPropertyName["VIRTUAL_CARD"] = "VIRTUAL_CARD";
    PayCenterPropertyName["PLASTIC_CARD"] = "PLASTIC_CARD";
    PayCenterPropertyName["PRODUCTION_PARTNER"] = "PRODUCTION_PARTNER";
    PayCenterPropertyName["DIRECT_DEBIT"] = "DIRECT_DEBIT";
    PayCenterPropertyName["REFUND"] = "REFUND";
    PayCenterPropertyName["RENEWAL"] = "RENEWAL";
    PayCenterPropertyName["ACCOUNT_REPLENISHMENT"] = "ACCOUNT_REPLENISHMENT";
    PayCenterPropertyName["BANK_ACCOUNT_OPTION"] = "BANK_ACCOUNT_OPTION";
    PayCenterPropertyName["CUSTOM_PIN"] = "CUSTOM_PIN";
    PayCenterPropertyName["STANDARD_DESIGN"] = "STANDARD_DESIGN";
    PayCenterPropertyName["TRUSTED_CUSTOMER"] = "TRUSTED_CUSTOMER";
    PayCenterPropertyName["CREDIT_LIMIT"] = "CREDIT_LIMIT";
    PayCenterPropertyName["REVENUE_LIMIT"] = "REVENUE_LIMIT";
    PayCenterPropertyName["ATM_USAGE"] = "ATM_USAGE";
    PayCenterPropertyName["ATM_COUNT_LIMIT"] = "ATM_COUNT_LIMIT";
    PayCenterPropertyName["ATM_VOLUME_LIMIT"] = "ATM_VOLUME_LIMIT";
    PayCenterPropertyName["ATM_COUNT_LIMIT_MONTHLY"] = "ATM_COUNT_LIMIT_MONTHLY";
    PayCenterPropertyName["ATM_VOLUME_LIMIT_MONTHLY"] = "ATM_VOLUME_LIMIT_MONTHLY";
    PayCenterPropertyName["ATM_COUNT_LIMIT_CALMONTHLY"] = "ATM_COUNT_LIMIT_CALMONTHLY";
    PayCenterPropertyName["ATM_VOLUME_LIMIT_CALMONTHLY"] = "ATM_VOLUME_LIMIT_CALMONTHLY";
    PayCenterPropertyName["POS_COUNT_LIMIT"] = "POS_COUNT_LIMIT";
    PayCenterPropertyName["POS_VOLUME_LIMIT"] = "POS_VOLUME_LIMIT";
    PayCenterPropertyName["POS_COUNT_LIMIT_MONTHLY"] = "POS_COUNT_LIMIT_MONTHLY";
    PayCenterPropertyName["POS_VOLUME_LIMIT_MONTHLY"] = "POS_VOLUME_LIMIT_MONTHLY";
    PayCenterPropertyName["ECOMMERCE_COUNT_LIMIT"] = "ECOMMERCE_COUNT_LIMIT";
    PayCenterPropertyName["ECOMMERCE_VOLUME_LIMIT"] = "ECOMMERCE_VOLUME_LIMIT";
    PayCenterPropertyName["ECOMMERCE_COUNT_LIMIT_MONTHLY"] = "ECOMMERCE_COUNT_LIMIT_MONTHLY";
    PayCenterPropertyName["ECOMMERCE_VOLUME_LIMIT_MONTHLY"] = "ECOMMERCE_VOLUME_LIMIT_MONTHLY";
    PayCenterPropertyName["ECOMMERCE_LVT_VOLUME_LIMIT"] = "ECOMMERCE_LVT_VOLUME_LIMIT";
    PayCenterPropertyName["TOTAL_COUNT_LIMIT"] = "TOTAL_COUNT_LIMIT";
    PayCenterPropertyName["TOTAL_VOLUME_LIMIT"] = "TOTAL_VOLUME_LIMIT";
    PayCenterPropertyName["TOTAL_VOLUME_LIMIT_CALMONTHLY"] = "TOTAL_VOLUME_LIMIT_CALMONTHLY";
    PayCenterPropertyName["TOTAL_VOLUME_LIMIT_LIFETIME"] = "TOTAL_VOLUME_LIMIT_LIFETIME";
    PayCenterPropertyName["SINGLE_VOLUME_LIMIT"] = "SINGLE_VOLUME_LIMIT";
    PayCenterPropertyName["CASH_VOLUME_LIMIT_CALMONTHLY"] = "CASH_VOLUME_LIMIT_CALMONTHLY";
    PayCenterPropertyName["COMMUNITY_CASH_VOLUME_LIMIT_CALMONTHLY"] = "COMMUNITY_CASH_VOLUME_LIMIT_CALMONTHLY";
    PayCenterPropertyName["RESTRICTED_COUNTRY_ATM_VOLUME_LIMIT"] = "RESTRICTED_COUNTRY_ATM_VOLUME_LIMIT";
    PayCenterPropertyName["LVT_COUNT_LIMIT"] = "LVT_COUNT_LIMIT";
    PayCenterPropertyName["LVT_VOLUME_LIMIT"] = "LVT_VOLUME_LIMIT";
    PayCenterPropertyName["MDES_COUNT_LIMIT"] = "MDES_COUNT_LIMIT";
    PayCenterPropertyName["MDES_VOLUME_LIMIT"] = "MDES_VOLUME_LIMIT";
    PayCenterPropertyName["EMV_CONTACTLESS_COUNT_LIMIT"] = "EMV_CONTACTLESS_COUNT_LIMIT";
    PayCenterPropertyName["EMV_CONTACTLESS_VOLUME_LIMIT"] = "EMV_CONTACTLESS_VOLUME_LIMIT";
    PayCenterPropertyName["EMV_MAGSTRIPE_COUNT_LIMIT"] = "EMV_MAGSTRIPE_COUNT_LIMIT";
    PayCenterPropertyName["EMV_MAGSTRIPE_VOLUME_LIMIT"] = "EMV_MAGSTRIPE_VOLUME_LIMIT";
    PayCenterPropertyName["NON_ONLINE_PIN_COUNT_LIMIT"] = "NON_ONLINE_PIN_COUNT_LIMIT";
    PayCenterPropertyName["NON_ONLINE_PIN_VOLUME_LIMIT"] = "NON_ONLINE_PIN_VOLUME_LIMIT";
    PayCenterPropertyName["SIGNATURE_COUNT_LIMIT"] = "SIGNATURE_COUNT_LIMIT";
    PayCenterPropertyName["SIGNATURE_COUNT_LIMIT_MONTHLY"] = "SIGNATURE_COUNT_LIMIT_MONTHLY";
    PayCenterPropertyName["SIGNATURE_VOLUME_LIMIT"] = "SIGNATURE_VOLUME_LIMIT";
    PayCenterPropertyName["SIGNATURE_VOLUME_LIMIT_MONTHLY"] = "SIGNATURE_VOLUME_LIMIT_MONTHLY";
    PayCenterPropertyName["FX_TXN_FEE"] = "FX_TXN_FEE";
    PayCenterPropertyName["MONEYSEND_RECEIVE"] = "MONEYSEND_RECEIVE";
    PayCenterPropertyName["INSTANT_REPLENISHMENT_VOLUME_LIMIT"] = "INSTANT_REPLENISHMENT_VOLUME_LIMIT";
    PayCenterPropertyName["INSTANT_REPLENISHMENT_UNCLEARED_VOLUME_LIMIT"] = "INSTANT_REPLENISHMENT_UNCLEARED_VOLUME_LIMIT";
    PayCenterPropertyName["WALLET_PROVIDER"] = "WALLET_PROVIDER";
    PayCenterPropertyName["LOUNGES_PACKAGE"] = "LOUNGES_PACKAGE";
    PayCenterPropertyName["MONDO_BASIC_CARD"] = "MONDO_BASIC_CARD";
    PayCenterPropertyName["MONDO_EXPLORER_CARD"] = "MONDO_EXPLORER_CARD";
})(PayCenterPropertyName || (PayCenterPropertyName = {}));
export var PayCenterConstraintName;
(function (PayCenterConstraintName) {
    PayCenterConstraintName["ACCOUNT_LEGITIMATED"] = "ACCOUNT_LEGITIMATED";
    PayCenterConstraintName["ADDRESS_CHECK"] = "ADDRESS_CHECK";
    PayCenterConstraintName["TITLE_SET"] = "TITLE_SET";
    PayCenterConstraintName["CARD_ACTIVE"] = "CARD_ACTIVE";
    PayCenterConstraintName["PLASTIC_CARD_DESIGN_CONFIRMED"] = "PLASTIC_CARD_DESIGN_CONFIRMED";
    PayCenterConstraintName["CHECK_RENEWAL_ORDERABLE"] = "CHECK_RENEWAL_ORDERABLE";
    PayCenterConstraintName["MOBILE_SET"] = "MOBILE_SET";
    PayCenterConstraintName["MOBILE_CONFIRMED"] = "MOBILE_CONFIRMED";
    PayCenterConstraintName["DIRECT_DEBIT_AUTHORIZATION"] = "DIRECT_DEBIT_AUTHORIZATION";
    PayCenterConstraintName["NON_FRAUDULENT"] = "NON_FRAUDULENT";
    PayCenterConstraintName["USER_TRUSTED"] = "USER_TRUSTED";
    PayCenterConstraintName["MIN_ACCOUNT_MOVEMENTS"] = "MIN_ACCOUNT_MOVEMENTS";
})(PayCenterConstraintName || (PayCenterConstraintName = {}));
export var PayCenterPropertyBean;
(function (PayCenterPropertyBean) {
    PayCenterPropertyBean["SINGLE_VALUE"] = "SingleValue";
})(PayCenterPropertyBean || (PayCenterPropertyBean = {}));
//# sourceMappingURL=paycenter.types.js.map